import { AnyAction } from "redux";

import { CondominiumDTO } from "models/dto/CondominiumDTO";
import { PeriodDTO } from "models/dto/PeriodDTO";

import { authenticationActionTypes } from "../actions/authActions";
import { condominiumActionsTypes } from "../actions/condominiumActions";

export interface CondominiumReducerData {
  loading: boolean;
  loadingPeriods: boolean;
  condominiums: CondominiumDTO[];
  condominiumSelected: CondominiumDTO | null;
  periods: PeriodDTO[];
}

export const ALL_CONDOMINIUMS: CondominiumDTO = {
  referencia: 0,
  nome: "Todos",
  cnpj: "",
  layout: {},
};

const INITIAL_STATE = {
  loading: false,
  loadingPeriods: false,
  condominiumSelected: null,
  //   referencia: 9010,
  //   nome: '',
  //   cnpj: '',
  condominiums: [],
  periods: [],
};

export default (
  state: CondominiumReducerData = INITIAL_STATE,
  action: AnyAction,
) => {
  switch (action.type) {
    case condominiumActionsTypes.CHANGE_CONDOMINIUM:
      return {
        ...state,
        condominiumSelected: action.payload,
      };

    case condominiumActionsTypes.GET_CONDOMINIUMS:
      return {
        ...state,
        loading: true,
      };

    case condominiumActionsTypes.GET_CONDOMINIUMS_SUCCESS:
      return {
        ...state,
        condominiums: action.payload,
        loading: false,
      };

    case condominiumActionsTypes.GET_CONDOMINIUMS_FAILURE:
      return {
        ...state,
        loading: false,
        condominiums: [],
      };

    case condominiumActionsTypes.GET_PERIODS:
      return {
        ...state,
        loadingPeriods: true,
      };

    case condominiumActionsTypes.GET_PERIODS_SUCCESS:
      return {
        ...state,
        periods: action.payload,
        loadingPeriods: false,
      };

    case condominiumActionsTypes.GET_PERIODS_FAILURE:
      return {
        ...state,
        loadingPeriods: false,
        periods: [],
      };

    case authenticationActionTypes.LOGOUT:
      return INITIAL_STATE;

    default:
      return state;
  }
};
